import { ErrorView } from './ErrorView';

export const ApplicationError = ({ error }: { error?: Error }) => {
  return <ErrorView variant="fullscreen" cause={error} />;
};
